export default function ProblemSection() {
  const problems = [
    "Missing family milestones",
    "Always busy, never fulfilled",
    "Trapped in the scroll",
    "Always 'on call'",
    "Health keeps slipping",
    "Living for the weekend",
  ];

  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 md:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center space-y-12 mb-20">
            <div className="space-y-6">
              <span className="text-primary text-sm font-bold tracking-wider uppercase">
                COMMON PATTERNS
              </span>
              <h2 className="text-3xl md:text-5xl xl:text-6xl font-bold md:font-extrabold leading-[0.9] tracking-tighter text-foreground max-w-4xl mx-auto">
                If this sounds familiar,{" "}
                <span className="text-primary">you're not alone:</span>
              </h2>
            </div>
            <div className="w-24 h-1 bg-primary mx-auto"></div>
          </div>

          {/* Problem grid - Brutal layout */}
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-8">
            {problems.map((problem, index) => (
              <div
                key={index}
                className="bg-card border-2 border-border p-8 hover:border-primary hover:shadow-brutal hover:translate-x-1 hover:translate-y-1 transition-spring group"
              >
                <div className="space-y-6">
                  <div className="w-8 h-8 bg-primary group-hover:bg-background transition-colors"></div>
                  <h3 className="text-xl font-bold text-foreground leading-tight">
                    {problem}
                  </h3>
                </div>
              </div>
            ))}
          </div>

          {/* Bottom statement */}
          <div className="text-center mt-20">
            <p className="text-2xl xl:text-3xl font-bold text-foreground max-w-3xl mx-auto leading-tight">
              1440 is built to fix exactly these patterns—by helping you make
              time for{" "}
              <span className="text-primary">what actually matters.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
